module.exports = __webpack_public_path__ + "static/img/Jason-Davidson.3c06112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason-Davidson.jpg
// module id = t2Lg
// module chunks = 0